module.exports = __webpack_public_path__ + "img/7966a0d73d52c05418b8624cac02f62b.svg";